/**
 * Логика стен: материал по енаму и по id из каталога.
 */
import { wallSection } from "./catalog";
import { DEFAULT_WALL_MATERIAL } from "./constants";
import type { WallCatalogItem, WallMaterial } from "./types";

/** Материал стены из каталога; неизвестный — материал по умолчанию. */
export const getMaterial = (material: WallMaterial | undefined): WallCatalogItem =>
	wallSection.items.find((item) => item.material === (material ?? DEFAULT_WALL_MATERIAL)) ??
	wallSection.items[0];

export const wallItemById = (id: string): WallCatalogItem | null =>
	wallSection.items.find((item) => item.id === id) ?? null;
